// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d449857","223":"e83c2840","239":"f855df25","667":"863d9de3"}[chunkId] + ".chunk.js";
};